module.exports = __webpack_public_path__ + "img/elementlengths_jakp.aa054efb.png";